"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventSeasonStencil = exports.eventSeasonStencilDefinition = void 0;
const properties_1 = require("../properties");
const label_property_1 = require("../properties/label.property");
const season_number_property_1 = require("../properties/season-number.property");
const series_property_1 = require("../properties/series.property");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'title',
            'label',
            'teaser',
            'description',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'series',
                    'season-number',
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'logos',
                    'featured-media',
                    'featured-video',
                ],
            },
            {
                name: 'Settings',
                items: ['standalone'],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: ['disciplines', 'content-categories'],
    },
];
exports.eventSeasonStencilDefinition = {
    view: {
        label: 'Event Season',
        category: 'event',
        group: 'Events & Projects',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'label',
                    'teaser',
                    'description',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'series',
                            'season-number',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'logos',
                            'featured-media',
                            'featured-video',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-persons',
                ],
            },
        ],
    },
    content: {
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        description: properties_1.descriptionPropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        'featured-media': {
            ...properties_1.featuredMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        label: label_property_1.labelPropertyDefinition,
        logos: properties_1.logosPropertyDefinition,
        'season-number': season_number_property_1.seasonNumberPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        series: {
            ...series_property_1.seriesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['event-series'],
                },
            ],
        },
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'media-partnerships',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-powertrains',
        'redbull-racing',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
    ],
    name: 'event-season',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
};
const isEventSeasonStencil = (stencil) => {
    return stencil.name === exports.eventSeasonStencilDefinition.name;
};
exports.isEventSeasonStencil = isEventSeasonStencil;
//# sourceMappingURL=data:application/json;base64,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